<template>
  <div>
    <gmsqlb />
  </div>
</template>

<script>
// 获取接口地址
import Gmsqlb from '@/components/buyRequest/gmsqlb.vue'

export default {
  name: 'Gmsq',
  components: {
    // sideMenu,
    // Header,
    Gmsqlb
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
